export default new class EventsHelper {
    constructor() {
        this.favoriteCounterList = document.querySelectorAll('.fs-favorite-counter');
        this.cartCounterList = document.querySelectorAll('.fs-cart-counter');

        this.classNoScroll = 'fs--no-scroll';

        this.scrollBarPosition = null;
    }

    onAddToFavorite = () => this.setNewValueOnAdd(this.favoriteCounterList);
    onAddToCart = () => this.setNewValueOnAdd(this.cartCounterList);
        
    onRemoveFromFavorite = () =>  this.setNewValueOnRemove(this.favoriteCounterList);
    onRemoveFromCart = () => this.setNewValueOnRemove(this.cartCounterList)

    setNewValueOnAdd(counter) {
        let value = counter[0].innerHTML;
        let newValue = value == "" ? 1 : parseInt(value) + 1;

        counter.forEach(x => x.innerHTML = newValue);
    }

    setNewValueOnRemove(counter) {
        let value = parseInt(counter[0].innerHTML);
        let newValue = value == 0 ? '': value - 1;

        counter.forEach(x => x.innerHTML = newValue == 0 ? '' : newValue )
    }

    hideScrollBar() {
        this.saveScrollPosition();
        const scrollBarWidth = this.getScrollBarWidth();

        document.body.classList.add(this.classNoScroll);
        document.body.style.cssText = `padding-right: ${scrollBarWidth}px;`;
    }

    returnScrollBar() {
        document.body.classList.remove(this.classNoScroll);
        document.body.style.cssText = `padding-right: 0px;`;
        window.scroll(0, this.offsetTop)
    }

    saveScrollPosition() {
        this.offsetTop = window.pageYOffset;
    }

    getScrollBarWidth() {
        return window.innerWidth - document.documentElement.clientWidth
    }
}